<template>
  <div id="faqpage">
    <div>
      <div class="main-heading inner">
        <!-- <div class="inner"> -->
	<p class="sub">Frequently Asked Questions</p>
	<h2>よくある質問</h2>
      </div>

      <section class="qa inner clearfix">
        <p class="qa_tx clearfix">「マシンの操作は簡単ですか？」「もしも故障した時はどうすればよいですか？」といったお客さまからの質問について
          主なものをQ&A形式にまとめました。お困りごと・お悩みの解決にお役立ていただけましたら幸いです。
          また、このページに掲載されていないご質問や、もっと詳しくお知りになりたい内容などがございましたら、
          質問フォームよりお気軽にお問い合わせください。
          <router-link to="/contact"><span class="btn">お問い合わせはこちら</span></router-link>
        </p>

        <div class="clearfix">
          <h3>よくある質問一覧</h3>
          <dl class="qa_list clearfix">
	    <dt>機器について</dt>
	    <dd><router-link to="#q01">Q.日本エステティック機器認定とは何ですか？</router-link></dd>
	    <dd><router-link to="#q02">Q.国産と純国産というのをよく聞きますが、何が違いますか？</router-link></dd>
	    <dd><router-link to="#q03">Q.純国産のメリットは何ですか？</router-link></dd>
	    <dd><router-link to="#q04">Q.マシンの操作は簡単ですか？</router-link></dd>
	    <dd><router-link to="#q05">Q.初心者ですがマシンは使えますか？</router-link></dd>
	    <dd><router-link to="#q06">Q.購入方法は何がありますか？</router-link></dd>
          </dl>
          <dl class="qa_list clearfix">
	    <dt>サポートについて</dt>
	    <dd><router-link to="#q07">Q.機械導入後、どのようなサポートがありますか？</router-link></dd>
	    <dd><router-link to="#q08">Q.新規開業支援はありますか？</router-link></dd>
	    <dd><router-link to="#q09">Q.機器の保証期間はどれくらいですか？</router-link></dd>
	    <dd><router-link to="#q10">Q.もしも故障した時はどうすればよいですか？</router-link></dd>
          </dl>
        </div>

        <h4>機器について</h4>

        <!--  set  -->	
        <div class="waku mt20" id="q01">
          <dl class="qa_box">
            <dt>日本エステティック機器認定とは何ですか？</dt>
            <dd>エステティック機器認証は、共通規格と個別規格を定めて認定試験機関で「製品試験」及び機械の安全性や使用者に対して配慮されているかどうかを確認する「システム審査」を行い、合格した製品のみ与えられる「機器認証マーク」です。弊社の脱毛機であるパワーライトシリーズは日本エステティック機構(JEO)の認定機器でありながら、美容ライト機器適合審査制度に合格した機器である日本エステティック振興協議会(JEPA)適合機です。
            </dd>
          </dl>
        </div>
        <!--  //set  -->
        <!--  set  -->	
        <div class="waku mt20" id="q02">
          <dl class="qa_box">
            <dt>国産と純国産というのをよく聞きますが、何が違いますか？</dt>
            <dd>実は、海外の部品を使用しても最後の機器の組み立てを日本ですると国産といえます。それに対し、部品の開発・製造から組み立てまで一貫してすべて日本国内で行った製品が純国産です。弊社の機械は自社で開発し、製造から組み立てまで日本国内で丁寧に行っている純国産品です。
            </dd>
          </dl>
        </div>
        <!--  //set  -->
        <!--  set  -->	
        <div class="waku mt20" id="q03">
          <dl class="qa_box">
            <dt>純国産のメリットは何ですか？</dt>
            <dd>パーツ管理やリペアもサービスの一貫で何年経っても部品がすぐ手に入るので万が一の場合でもご安心してお使いいただけます。また、精密で耐久性に優れている安全性の高い機械となり、寿命が長いのが特徴です。
            </dd>
          </dl>
        </div>
        <!--  //set  -->
        <!--  set  -->	
        <div class="waku mt20" id="q04">
          <dl class="qa_box">
            <dt>マシンの操作は簡単ですか？</dt>
            <dd>はい。弊社のマシンはどなたでもお使いいただけるように使用方法が簡単です。また、導入時及び導入後にも丁寧にご対応致しますのでご安心ください。
            </dd>
          </dl>
        </div>
        <!--  //set  -->
        <!--  set  -->	
        <div class="waku mt20" id="q05">
          <dl class="qa_box">
            <dt>初心者ですがマシンは使えますか？</dt>
            <dd>はい。初心者の方でも導入時にしっかり研修を実施しておりますのですぐお使いいただけるようになります。
            </dd>
          </dl>
        </div>
        <!--  //set  -->
        <!--  set  -->	
        <div class="waku mt20" id="q06">
          <dl class="qa_box">
            <dt>購入方法は何がありますか？</dt>
            <dd>現金払いからクレジット払いも可能です。その他ローンなど各種用意もございますのでお気軽にご相談ください。
            </dd>
          </dl>
        </div>
        <!--  //set  -->


        <h5>サポートについて</h5>

        <!--  set  -->	
        <div class="waku mt20" id="q07">
          <dl class="qa_box">
            <dt>機械導入後、どのようなサポートがありますか？</dt>
            <dd>導入後には初心者導入研修のほか、技術指導とフォロー研修まで様々な研修を御用敷いております。また、脱毛や肌に対する基礎知識、メニュー提案、顧客獲得や売り上げアップのためのチラシやポスターPOP、広告用ツールなども提供もさせていただきます。(一部有料)
            </dd>
          </dl>
        </div>
        <!--  //set  -->

        <!--  set  -->	
        <div class="waku mt20" id="q08">
          <dl class="qa_box">
            <dt>新規開業支援はありますか？</dt>
            <dd>はい。弊社の20年の実績を元に今までの経験とノウハウを生かしてサロンの開業を支援いたします。エステ業界の未経験の方や異業種の方も安心してビジネスを展開していただけるようにサポートしています。美容関係のニュースやサロン運営に関することも全般的にお手伝いさせていただきます。
            </dd>
          </dl>
        </div>
        <!--  //set  -->
        
        <!--  set  -->	
        <div class="waku mt20" id="q09">
          <dl class="qa_box">
            <dt>機器の保証期間はどれくらいですか？</dt>
            <dd>パワーライトシリーズは2年です。また、機種によって期間が異なりますので気軽にお問い合わせください。
            </dd>
          </dl>
        </div>
        <!--  //set  -->

        <!--  set  -->	
        <div class="waku mt20" id="q10">
          <dl class="qa_box">
            <dt>もしも故障した時はどうすればよいですか？</dt>
            <dd>もしトラブルや機械に不具合がある場合には弊社にご連絡ください。「土日祝(9:00-18:00)もサービスコール受付、48時間以内対応」というメンテナンス体制をしておりますので弊社のエンジニアが迅速に対応させていただきます。また、備え代替機もおりますのでご安心ください。(在庫の状況によっては対応できかねます場合にもございます。)
            </dd>
          </dl>
        </div>
        <!--  //set  -->
      </section>
    </div>

    <scfooter></scfooter>
  </div>
</template>

<script>

 export default {
   name: 'faq',
   components: {
     scfooter: () => import('../components/scFooter.vue')
   },

   /* http://peccu.hatenablog.com/entry/2017/11/18/000000
      Vue.js+VueRouterを使っているときに#idでページ内を移動する */
   watch: {
     '$route': function (n, o) {
       if (n.hash.match(/^#/)) {
         document.getElementById(n.hash.replace(/^#/, '')).scrollIntoView()
       }
       console.log('new, old', [n.hash, o.hash])
     }
   },
   mounted () {
     if (this.$route.hash.match(/^#/)) {
       document.getElementById(this.$route.hash.replace(/^#/, '')).scrollIntoView()
     }
   }
   
 }
</script>

<style lang="scss" scoped>
 #faqpage {
   width: 100%;
 }

 @charset "UTF-8";
 dl,
 dt,
 dd,
 section {
   margin: 0;
   padding: 0;
   color: #161515;
   font-size: 16px;
   font-weight: normal;
   font-style: normal;
   font-family: "ヒラギノ角ゴシック Pro", "Hiragino Kaku Gothic Pro", "ＭＳ Ｐゴシック", "MS PGothic", 'メイリオ', Meiryo, Osaka, sans-serif;
   line-height: 1.8;
   vertical-align: baseline;
   background: transparent;
   box-sizing: border-box;
   border: none;
 }
 
 body {
   min-width: 960px;
 }
 
 a,
 article,
 aside,
 canvas,
 details,
 figcaption,
 figure,
 header,
 footer,
 main,
 menu,
 nav,
 section,
 summary {
   display: block;
 }
 
 img {
   border: 0;
   display: block;
   height: auto;
 }
 
 table {
   border-spacing: 0;
   border-collapse: collapse;
 }
 
 ul,
 li {
   list-style: none;
 }
 
 a {
   color: #161515;
   text-decoration: none;
   -webkit-transition: 02s ease;
   -moz-transition: 0.2s ease;
   -o-transition: 0.2s ease;
   transition: 0.2s ease;
 }
 
 a:hover {
   opacity: 0.8;
 }
 
 .inner {
   width: 960px;
   margin: 0 auto;
 }
 /* clearfix */
 
 .clearfix {
   zoom: 1;
 }
 
 .clearfix:after {
   content: "";
   display: block;
   clear: both;
 }
 
 .clear {
   clear: both;
 }
 
 /* .hiramin{font-family: "ヒラギノ明朝 ProN W3", "HiraMinProN-W3","ＭＳ Ｐ明朝", "MS PMincho"} */
 /* .mincho {font-family:"游明朝", YuMincho, "ヒラギノ明朝 ProN W3", "Hiragino Mincho ProN", "HG明朝E", "ＭＳ Ｐ明朝", serif;} */
 /* .text-orange{color: #fd9429;} */
 /* qa
    ----------------------------------*/

 .qa_tx {
   font-size: 16px;
 }
 
 .qa a .btn {
   padding: 10px 80px 10px;
   margin: 10px 30px;
   color: #666;
   font-size: 20px;
   background: #fff;
   display: inline-block;
   border: 1px solid #aaa;
   border-radius: 3px;
   float: right;
 }
 
 .qa a .btn:after {
   content: "\f0da";
   margin: 0 5px;
   font-size: 18px;
   line-height: 1;
   margin: 0 10px;
   display: inline-block;
   font: normal normal normal 14px/1 FontAwesome;
   font-size: inherit;
   text-rendering: auto;
   -webkit-font-smoothing: antialiased;
   -moz-osx-font-smoothing: grayscale;
 }
 
 .qa a:hover .btn {
   background: #ffa237;
 }
 
 .qa_list {
   margin-bottom: 30px;
 }
 
 .qa_list dt {
   font-size: 24px;
   color: #fd9429;
   margin-top: 16px;
   border-bottom: solid #fd9429 2px;
 }
 
 .qa_list dd {
   width: 48%;
   float: left;
   margin-right: 10px;
   margin-bottom: 5px;
   position: relative;
 }
 
 .qa_list dd a {
   font-size: 14px;
   background: #eee;
   position: relative;
   padding: 10px;
 }
 
 .qa_list dd a:after {
   position: absolute;
   right: 0;
   content: "\f0d7";
   margin: 0 5px;
   font-size: 18px;
   line-height: 1;
   margin: 0 10px;
   display: inline-block;
   font: normal normal normal 14px/1 FontAwesome;
   font-size: inherit;
   text-rendering: auto;
   -webkit-font-smoothing: antialiased;
   -moz-osx-font-smoothing: grayscale;
 }
 
 .qa_list dd:hover {
   background: #fafafa;
 }
 
 .qa h3 {
   font-size: 26px;
   border-bottom: 2px solid #666;
   margin-top: 30px;
   color: #666;
 }
 
 .qa h4,
 .qa h5 {
   font-size: 26px;
   border-bottom: 2px solid #fd9429;
   margin-top: 50px;
   color: #fd9429;
 }
 
 .waku {
   margin-top: 20px;
   width: auto;
   height: auto;
   padding: 3%;
   text-align: left;
   color: #333333;
   border: 2px solid #ccc;
   border-radius: 10px;
   -webkit-border-radius: 10px;
   -moz-border-radius: 10px;
 }
 
 .qa_box dt {
   min-height: 50px;
   height: auto !important;
   height: 40px;
   border-bottom: 1px dotted #ccc;
   padding-left: 50px;
   padding-top: 10px;
   color: #666;
   background: url(/assets/img/qaQ.jpg) no-repeat 3px 5px;
 }
 
 .qa_box dd {
   text-align: left;
   min-height: 40px;
   height: auto !important;
   height: 40px;
   padding: 10px 0px 0px 50px;
   margin-top: 5px;
   background: url(/assets/img/qaA.jpg) no-repeat 3px 5px;
 }
 
 .qa_box strong {
   color: #EB7701;
 }
 
 .main-heading {
   padding: 15px 0 5px;
   margin-bottom: 50px;
   text-align: center;
   /* border-bottom: 1px solid #000; */
   position: relative;
 }
 
 .main-heading:after {
   content: '';
   width: 38px;
   height: 20px;
   margin-left: -10px;
   background: url(/assets/img/main_heading_bg.jpg) no-repeat;
   position: absolute;
   left: 50%;
   bottom: -20px;
 }
 
 .main-heading p {
   margin-bottom: 5px;
   color: #616161;
   font-size: 22px;
   position: relative;
 }
 
 .main-heading p:after {
   content: '';
   width: 50px;
   margin-left: -25px;
   /* border-bottom: 1px solid #000; */
   position: absolute;
   left: 50%;
   bottom: 1px;
 }
 
 .main-heading h2 {
   font-size: 36px;
 }
 
 @media only screen and (max-width: 600px) {
   body {min-width: 100%;}
   .inner{width: 100%;}

   /* qa
      ----------------------------------*/
   .qa {
     padding: 3%;
   }
   
   .qa_tx {
     font-size: 16px;
   }
   
   .qa a .btn {
     padding: 3%;
     margin: 3% 3%;
     color: #666;
     font-size: 20px;
     background: #fff;
     display: inline-block;
     border: 1px solid #aaa;
     border-radius: 3px;
     float: right;
   }
   
   .qa a .btn:after {
     content: "\f0da";
     margin: 0 1%;
     font-size: 18px;
     line-height: 1;
     margin: 0 10px;
     display: inline-block;
     font: normal normal normal 14px/1 FontAwesome;
     font-size: inherit;
     text-rendering: auto;
     -webkit-font-smoothing: antialiased;
     -moz-osx-font-smoothing: grayscale;
   }
   
   .qa a:hover .btn {
     background: #ffa237;
   }
   
   .qa_list {
     margin-bottom: 3%;
   }
   
   .qa_list dt {
     font-size: 24px;
     color: #fd9429;
     margin-top: 3%;
     border-bottom: solid #fd9429 2px;
   }
   
   .qa_list dd {
     width: 100%;
     float: left;
     margin-right: 3%;
     margin-bottom: 5px;
     position: relative;
   }
   
   .qa_list dd a {
     font-size: 14px;
     background: #eee;
     position: relative;
     padding: 3%;
   }
   
   .qa_list dd a:after {
     position: absolute;
     right: 0;
     content: "\f0d7";
     margin: 0 1%;
     font-size: 18px;
     line-height: 1;
     margin: 0 10px;
     display: inline-block;
     font: normal normal normal 14px/1 FontAwesome;
     font-size: inherit;
     text-rendering: auto;
     -webkit-font-smoothing: antialiased;
     -moz-osx-font-smoothing: grayscale;
   }
   
   .qa_list dd:hover {
     background: #fafafa;
   }
   
   .qa h3 {
     font-size: 26px;
     border-bottom: 2px solid #666;
     margin-top: 3%;
     color: #666;
   }
   
   .qa h4,
   .qa h5 {
     font-size: 26px;
     border-bottom: 2px solid #fd9429;
     margin-top: 3%;
     color: #fd9429;
   }
   
   .waku {
     width: auto;
     height: auto;
     padding: 3%;
     text-align: left;
     color: #333333;
     border: 2px solid #ccc;
     border-radius: 10px;
     -webkit-border-radius: 10px;
     -moz-border-radius: 10px;
   }
   
   .qa_box dt {
     min-height: 50px;
     height: auto !important;
     height: 40px;
     border-bottom: 1px dotted #ccc;
     padding-left: 50px;
     padding-top: 10px;
     color: #666;
     background: url(/assets/img/qaQ.jpg) no-repeat 3px 5px;
   }
   
   .qa_box dd {
     text-align: left;
     min-height: 40px;
     height: auto !important;
     height: 40px;
     padding: 3% 0px 0px 50px;
     margin-top: 1%;
     background: url(/assets/img/qaA.jpg) no-repeat 3px 5px;
   }
   
 }

 
 @media (min-width: 601px) {
   #faqpage {
     margin-top: 80px; /* to deal with floating menu*/
   }
 }


 .faqsection {
   margin-top: 60px;
 }

 .container {
   /* width: 960px; */
   margin: 0 auto;
 }

</style>
